"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeyTerm = void 0;
const React = __importStar(require("react"));
const react_markdown_1 = __importDefault(require("react-markdown"));
const InlineCode_1 = require("./InlineCode");
const react_1 = require("@chakra-ui/react");
const chakra_helpers_1 = require("@apollo/chakra-helpers");
//prism themes after markdown code block
require("prismjs/components/prism-bash");
require("prismjs/components/prism-csharp");
require("prismjs/components/prism-diff");
require("prismjs/components/prism-graphql");
require("prismjs/components/prism-groovy");
require("prismjs/components/prism-java");
require("prismjs/components/prism-javascript");
require("prismjs/components/prism-json");
require("prismjs/components/prism-jsx");
require("prismjs/components/prism-tsx");
require("prismjs/components/prism-typescript");
require("prismjs/components/prism-yaml");
const brand_1 = require("@apollo/brand");
const KeyTerm = ({ definition, term }) => {
    const { border, bg: popOverBG } = brand_1.colors.tokens;
    const bg = (0, react_1.useColorModeValue)(popOverBG.secondary.base, brand_1.colors.primitives.navy[500]);
    const borderColor = (0, react_1.useColorModeValue)(border.secondary.base, border.secondary.dark);
    return (React.createElement(react_1.Popover, { onOpen: () => {
            var _a;
            (_a = window.gtag) === null || _a === void 0 ? void 0 : _a.call(window, "event", "apollopedia_open", {
                term: term.toLowerCase(),
            });
        } },
        React.createElement(react_1.PopoverTrigger, null,
            React.createElement(react_1.chakra.span, { sx: {
                    textDecoration: "underline",
                    textDecorationStyle: "dotted",
                    textDecorationThickness: "1.5px",
                    textDecorationColor: "gray.300",
                    textUnderlineOffset: "0.2em",
                    _dark: {
                        textDecorationColor: "blue.400",
                    },
                }, _hover: { cursor: "help" } }, term)),
        React.createElement(react_1.Portal, null,
            React.createElement(react_1.PopoverContent, { borderColor: borderColor, bg: bg, minW: "sm", w: definition.length > 500
                    ? "xl"
                    : definition.length > 300
                        ? "md"
                        : "sm", _focus: {
                    boxShadow: `2px 2px 8px 0px rgba(0, 0, 0, 0.14)`,
                    _dark: {
                        boxShadow: `2px 2px 8px 0px rgba(54, 94, 114, 0.4)`,
                    },
                } },
                React.createElement(react_1.PopoverArrow, { bg: bg }),
                React.createElement(react_1.PopoverCloseButton, null),
                React.createElement(react_1.PopoverHeader, { borderColor: borderColor, fontWeight: "bold" }, term),
                React.createElement(react_1.PopoverBody, { fontSize: "0.9em", lineHeight: "1.3em", px: "4", pb: "4" },
                    React.createElement(react_1.Stack, { spacing: "2" },
                        React.createElement(react_markdown_1.default, { components: {
                                code: InlineCode_1.InlineCode,
                                pre: (props) => React.createElement(chakra_helpers_1.MarkdownCodeBlock, Object.assign({}, props, { disableCopy: true })),
                                a: (props) => (React.createElement(react_1.Link, Object.assign({ color: "blue.400", _dark: { color: "navy.100" }, target: "_blank" }, props))),
                                ul: (props) => (React.createElement("div", null,
                                    React.createElement(react_1.UnorderedList, Object.assign({}, props)))),
                                ol: (props) => (React.createElement("div", null,
                                    React.createElement(react_1.OrderedList, Object.assign({}, props)))),
                                li: react_1.ListItem,
                            } }, definition)))))));
};
exports.KeyTerm = KeyTerm;
//# sourceMappingURL=KeyTerm.js.map